import { FilterButton, Typography } from 'omakase';
import { Menu, MenuItem } from 'ui';
import {
  OfferingSearchTypeOrBusinessType,
  OfferingTypeOption,
  isBusinessType,
} from 'utils/searchBar';
import { SearchQueryStringParams } from 'components/search/utils';
import { Theme, makeStyles } from '@material-ui/core/styles';

interface Props {
  onOpen(e: React.MouseEvent<HTMLButtonElement>): void;
  experiencesLabel: React.ReactNode;
  isOpen: boolean;
  onCloseAndReset(): void;
  onClose(): void;
  onChangeType(type: OfferingSearchTypeOrBusinessType): void;
  onSearch(type: Partial<SearchQueryStringParams>): void;
  anchorEl?: HTMLButtonElement;
  typeOptions: OfferingTypeOption[];
  type?: OfferingSearchTypeOrBusinessType;
}

const useStyles = makeStyles((theme: Theme) => ({
  menuPaperRoot: {
    marginTop: theme.spacing(1),
    maxHeight: theme.typography.pxToRem(450),
  },
}));

const ExperienceTypeFilterButton: React.FunctionComponent<Props> = ({
  onOpen,
  experiencesLabel,
  isOpen,
  onClose,
  onCloseAndReset,
  onChangeType,
  onSearch,
  anchorEl,
  typeOptions,
  type,
}) => {
  const styles = useStyles();

  return (
    <>
      <FilterButton
        aria-haspopup
        aria-label="Change experience type filter"
        onClick={onOpen}
        selected={!!experiencesLabel}
        data-testid="filter-desktop-button"
      >
        {experiencesLabel}
      </FilterButton>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={onCloseAndReset}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        MenuListProps={{ variant: 'selectedMenu', autoFocusItem: true }}
        PopoverClasses={{ root: styles.menuPaperRoot }}
      >
        {isOpen &&
          typeOptions.map((typeOption, idx) => {
            const typeValue = typeOption.value;

            return (
              <MenuItem
                component={'button'}
                selected={typeOption.value === type}
                key={idx}
                onClick={() => {
                  onChangeType(typeValue);
                  onClose();
                  onSearch({
                    businessType: isBusinessType(typeValue) ? typeValue : undefined,
                    type: isBusinessType(typeValue) ? undefined : typeValue,
                  });
                }}
              >
                <Typography>{typeOption.label}</Typography>
              </MenuItem>
            );
          })}
      </Menu>
    </>
  );
};

export default ExperienceTypeFilterButton;
